"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenNotification = useOpenNotification;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var notification_1 = require("../features/apis/notification");
var notification_2 = require("../utils/notification");
function useOpenNotification() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var markNotificationRead = (0, notification_1.useMarkNotificationReadMutation)()[0];
    return (0, react_1.useCallback)(function (notification) {
        if (!notification.read) {
            markNotificationRead(notification.id);
        }
        navigate((0, notification_2.getNotificationPath)(notification));
    }, [markNotificationRead, navigate]);
}
